import { ReactComponent } from "./image-add-line.svg";

interface Props {
  fill?: string;
  width?: string;
  height?: string;
}

const ImageAddLineIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ImageAddLineIcon;
